export class CappedLine {
  constructor(source, target) {
    this.source = source
    this.target = target
  }

  toSVGCommand = () => {
    const source = this.source
    const target = this.target
    const capX = target.x - 10
    const capY = target.y - 40

    return `
      M ${source.x},${source.y}
      L ${source.x},${source.y}
        ${target.x},${capY}
      M ${capX},${capY}
      L ${capX},${capY}
        ${capX + 20},${capY}
    `
  }
}
